import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

import { type ArrowParams } from './tooltipPlacement';

const TooltipArrow = ({
  direction = 'down',
  left,
  top,
  transform,
}: ArrowParams) => (
  <div
    className={cn(
      'absolute z-30 block size-0 border-[10px] border-transparent',
      {
        'border-b-tiga-surface-darkest': direction === 'up',
        'border-l-tiga-surface-darkest': direction === 'right',
        'border-r-tiga-surface-darkest': direction === 'left',
        'border-t-tiga-surface-darkest': direction === 'down',
      },
    )}
    style={{
      left,
      top,
      transform,
    }}
  />
);

type P = PropsWithChildren<{
  readonly arrowParams: ArrowParams;
  readonly id?: string;
}> &
  ComponentStyling;

export const TooltipComponent = ({
  arrowParams,
  children,
  className,
  id,
  style,
}: P) => {
  return (
    <div
      className={cn(
        'pointer-events-none relative z-30 max-w-60 rounded-md bg-tiga-surface-darkest px-4 py-2 text-center text-sm whitespace-pre-line text-white shadow-md',
        className,
      )}
      id={id}
      role="tooltip"
      style={style}
    >
      {children}
      <TooltipArrow {...arrowParams} />
    </div>
  );
};
